import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'

const EditPassword = (props) => {
  const { setmodalEditPasswordOpen, modalEditPasswordOpen, dataShop } = props
  const { t } = useLocalization()
  const history = useHistory()
  // const params = useParams()

  const handleSubmit = async (data) => {
    setmodalEditPasswordOpen(false)
    try {
      await client.patch(`/shop/${data.id}/password`, {
        password: data.password,
      })
      message.success('สำเร็จ')
      history.push('/shop')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }
  return (
    <>
      <Modal
        centered={true}
        title={t('rewards.shop.edit.titlePassword')}
        open={modalEditPasswordOpen}
        onCancel={() => setmodalEditPasswordOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent
          handleSubmit={handleSubmit}
          doStatus="editPassword"
          defaultValues={dataShop}
        />
      </Modal>
    </>
  )
}

EditPassword.propTypes = {
  dataShop: PropTypes.object,
  setmodalEditPasswordOpen: PropTypes.func,
  modalEditPasswordOpen: PropTypes.bool,
}

export default EditPassword
